import { useEffect, useState } from "react";

import { useTranslation, withTranslation } from "react-i18next";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AppCard from "@plannel/components/ui/AppCard";
import CardContent from '@mui/material/CardContent';
import { indigo } from "@mui/material/colors";

import systemService from "@plannel/services/system/system-service";
import debug from "@plannel/utils/debug-util";
import { FS } from "@plannel/utils/font-util";

const PasswordPolicyContainer = () => {
  const { t } = useTranslation();
  const [passwordPoliciesInfo, setPasswordPoliciesInfo] = useState({});

  const retrievePasswordPolicies = () => {
    systemService.getPasswordPolicies()
      .then(response => {
        const { passwordPolicies } = response.data;
        setPasswordPoliciesInfo(passwordPolicies);
      })
      .catch(e => {
        debug(e);
      });
  }

  useEffect(() => {
    retrievePasswordPolicies();
  }, []);

  const setPasswordRules = info => {
    const { minLength, maxLength, maxRepeat, lcredit, ucredit, dcredit, ocredit } = info;

    const policyList = [
      t("MSG_CheckPasswordLength", { min: minLength, max: maxLength }),
      t("MSG_PasswordRepeat", { N: maxRepeat }),
      t("MSG_PasswordLCredit", { N: lcredit }),
      t("MSG_PasswordUCredit", { N: ucredit }),
      t("MSG_PasswordDCredit", { N: dcredit }),
      t("MSG_PasswordOCredit", { N: ocredit })
    ];

    return policyList.map(rule => {
      return (
        <Typography key={rule} variant="body2" gutterBottom>• {rule}</Typography>
      );
    });
  }

  return (
    <Box sx={{ overflow: "overlay" }}>
      <AppCard sx={{ background: indigo[100], overflow: "overlay" }}>
        <CardContent sx={{ p: '16px !important' }}>
          <Box sx={{ ml: 1, color: indigo[900] }}>
            <Typography variant="subtitle2" sx={{ fontSize: FS.H1 }} gutterBottom>{t("ruleForPassword")}</Typography>
            {setPasswordRules(passwordPoliciesInfo)}
          </Box>
        </CardContent>
      </AppCard>
    </Box>
  )
}

export default withTranslation()(PasswordPolicyContainer);